import React from 'react';

import { Flex, HStack, Text, Input, Button } from '@chakra-ui/react';

import { useColors } from './colors';

const Pagination = ({
  currentPage,
  totalPages,
  pageInput,
  setPageInput,
  handlePageChange,
  isLoading,
  listings,
}) => {
  const { inputColor } = useColors();

  // Helper function to generate pagination button range
  const getPaginationRange = () => {
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    let startPage = Math.max(currentPage - halfRange, 1);
    let endPage = Math.min(startPage + maxButtons - 1, totalPages);

    // Adjust start page if we're near the end
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(endPage - maxButtons + 1, 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  if (isLoading || !listings || listings.length === 0) {
    return null;
  }

  return (
    <Flex justify="space-between" align="center">
      <HStack spacing={2}>
        <Text fontSize="sm">Page</Text>
        <Input
          size="sm"
          type="number"
          value={pageInput}
          onChange={(e) => setPageInput(Number(e.target.value))}
          width="60px"
          color={inputColor}
        />
        <Text fontSize="sm">of {totalPages}</Text>
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            const page = parseInt(pageInput);
            if (page >= 1 && page <= totalPages) {
              handlePageChange(page);
            }
          }}
        >
          Go
        </Button>
      </HStack>

      <HStack spacing={2}>
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage <= 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </Button>
        {getPaginationRange().map((page) => (
          <Button
            key={page}
            size="sm"
            variant={parseInt(page) === parseInt(currentPage) ? 'solid' : 'outline'}
            colorScheme={parseInt(page) === parseInt(currentPage) ? 'blue' : 'gray'}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </Button>
        ))}
        {getPaginationRange()[getPaginationRange().length - 1] < totalPages && (
          <>
            <Text>...</Text>
            <Button
              size="sm"
              variant="outline"
              onClick={() => handlePageChange(totalPages)}
              colorScheme={
                parseInt(totalPages) === parseInt(currentPage) ? 'blue' : 'gray'
              }
            >
              {totalPages}
            </Button>
          </>
        )}
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage >= totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </Button>
      </HStack>
    </Flex>
  );
};

export default Pagination;
